import { sizes } from '@/utils'

import tag from '@/components/tag'

function renderCount(h) {
  if (this.isMany) {
    return h(
      tag,
      {
        props: {
          label: `+${this.value.length - this.count}`,
          size: sizes.tiny,
          tooltip: this.value.reduce((result, item, index) => {
            if (index < 20) {
              result.push(item)
            }

            return result
          }, []).join('\n')
        }
      }
    )
  }
}

function renderItem(h, item) {
  if (typeof item === 'string' && item) {
    return h(
      tag,
      {
        props: {
          label: item,
          size: sizes.tiny
        }
      }
    )
  }
}

function renderItems(h) {
  return this.value.slice(0, this.count).map(item => {
    return renderItem.call(this, h, item)
  })
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        'routes-conditions__condition-value': true,
        link: this.isMany
      },
      on: {
        click: () => {
          if (this.isMany) {
            this.$emit('click', true)
          }
        }
      }
    },
    [
      renderItems.call(this, h),
      renderCount.call(this, h)
    ]
  )
}
